'use server';

import { auth } from '@clerk/nextjs/server';
import { database } from '@flowmuse/schema/db';
import { parseError } from '@/lib/error/parse';
import { visionModels } from '@/lib/models/vision';
import { projects } from '@flowmuse/schema';
import { eq } from 'drizzle-orm';
import OpenAI from 'openai';

export const describeAction = async (
  url: string,
  projectId: string
): Promise<
  | {
      description: string;
    }
  | {
      error: string;
    }
> => {
  try {
    // 仅要求登录即可；上传后的自动描述不走余额拦截
    const { userId } = await auth();
    if (!userId) throw new Error('Please sign in to continue');

    const openai = new OpenAI({
      baseURL: 'https://yunwu.ai/v1',
      apiKey: process.env.YUNWU_API_KEY,
    });

    const project = await database.query.projects.findFirst({
      where: eq(projects.id, projectId),
    });

    if (!project) {
      throw new Error('Project not found');
    }

    const model = visionModels[project.visionModel];

    if (!model) {
      throw new Error('Model not found');
    }

    let parsedUrl = url;

    if (process.env.NODE_ENV !== 'production') {
      const response = await fetch(url);
      const blob = await response.blob();

      parsedUrl = `data:${blob.type};base64,${Buffer.from(await blob.arrayBuffer()).toString('base64')}`;
    }

    const response = await openai.chat.completions.create({
      model: model.providers[0].model.modelId,
      messages: [
        {
          role: 'user',
          content: [
            { type: 'text', text: '(Use Chinese) Describe this image.' },
            {
              type: 'image_url',
              image_url: {
                url: parsedUrl,
              },
            },
          ],
        },
      ],
    });

    const description = response.choices.at(0)?.message.content;

    if (!description) {
      throw new Error('No description found');
    }

    return {
      description,
    };
  } catch (error) {
    const message = parseError(error);

    return { error: message };
  }
};
